module.exports = __webpack_public_path__ + "img/seminar (59).550d87ec.jpg";